export default __webpack_public_path__ + "static/media/logo-small.22f7b14c.png";